
import { defineComponent, onMounted, ref } from "vue";
import ClientsTable from "@/components/widgets/sistena/ClientsTable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "account-overview",
  props:{
    model: String
  },
  components: {
    ClientsTable
  },
  setup() {
    const list = ref([]);
    const fetchModels = async () => {
      await ApiService.setHeader();
      const models = await ApiService.get("clients");
      list.value = models.data.clients;
      console.log(list.value);
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Overview", ["Account"]);
    });
    return {
      list,
      fetchModels
    };
  },
  created() {
    this.fetchModels();
  }
});
